var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.requests,"loading":_vm.loading,"options":_vm.options,"server-items-length":_vm.totalRequests,"footer-props":{
      itemsPerPageOptions: [12,24,48,-1]
    }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.created_at",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$moment.unix(item.created_at).fromNow())+" ")]}},{key:"item.actions",fn:function(ref){
    var item = ref.item;
return [_c('v-btn',{attrs:{"text":"","small":"","color":"error"},on:{"click":function($event){return _vm.closeRequest(item)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-close")])],1)]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }